import script from "./CollaborationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollaborationList.vue?vue&type=script&setup=true&lang=ts"

import "./CollaborationList.vue?vue&type=style&index=0&id=159081ec&lang=css"

const __exports__ = script;

export default __exports__